<mat-chip-listbox class="d-flex" [ngClass]="center() ? 'justify-content-center' : 'justify-content-start'">
  <span class="{{ avatarStyle[examStatus()].classColor }}">
    <mat-chip class="d-none d-lg-flex"
      ><mat-chip-avatar class="ps-1"><syn-status-avatar [examStatus]="examStatus()" [volume]="false" /></mat-chip-avatar
      >{{ avatarStyle[examStatus()].title }}</mat-chip
    >
    <syn-status-avatar class="d-lg-none d-flex" [examStatus]="examStatus()" [border]="true" />
  </span>
</mat-chip-listbox>
